import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=abaa1168&scoped=true&"
import script from "./Swiper.vue?vue&type=script&lang=js&"
export * from "./Swiper.vue?vue&type=script&lang=js&"
import style0 from "./Swiper.vue?vue&type=style&index=0&id=abaa1168&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abaa1168",
  null
  
)

export default component.exports